(() => {
      const text = new Map([
        ['Write a review', 'Írjon véleményt'],
        ['How would you rate this product?', 'Hogyan értékeli ezt a terméket?'],
        ['We would love it if you would share a bit about your experience.', 'Örömmel olvasnánk a tapasztalatait.'],
        ['Review content (Required)', 'Vélemény (kötelező)'],
        ["We'll only contact you about your review if necessary. By submitting your review, you agree to our terms and conditions and privacy policy.", 'Csak szükség esetén keressük meg a véleményével kapcsolatban. A vélemény elküldésével elfogadja a felhasználási feltételeket és az adatvédelmi tájékoztatót.'],
        ['About you', 'Önről'],
        ['Please tell us more about you.', 'Kérjük, adjon meg néhány adatot.'],
        ['Email address (Required)', 'E-mail-cím (kötelező)'],
        ['We respect your privacy.', 'Tiszteletben tartjuk az adatvédelmét.'],
        ['Display name (Required)', 'Megjelenített név (kötelező)'],
        ["This won't be visible to other customers.", 'Ez nem lesz látható más vásárlók számára.'],
        ['Post review as anonymous', 'Névtelen vélemény'],
        ['Share a picture', 'Kép megosztása'],
        ['Upload a photo to support your review.', 'Töltsön fel képet a véleményéhez.'],
        ['Click to upload or drag and drop', 'Kattintson a feltöltéshez, vagy húzza ide a fájlt'],
        ['Back', 'Vissza'],
        ['Next', 'Tovább'],
        ['Submit', 'Küldés'],
        ['Submit review', 'Vélemény elküldése'],
        ['Thanks for your review!', 'Köszönjük a véleményét!'],
        ['We are processing it and it will appear on the store soon.', 'Feldolgozzuk, és hamarosan megjelenik az áruházban.'],
        ['Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.', 'Kérjük, erősítse meg e-mail-címét az imént küldött hivatkozással. Ez segít megőrizni a vélemények hitelességét.'],
        ['Would you like to share your experience of shopping with us?', 'Megosztaná velünk vásárlási tapasztalatait?'],
        ['We value your feedback and use it to improve. Please share any thoughts or suggestions you have.', 'Fontos számunkra a visszajelzése. Kérjük, ossza meg velünk észrevételeit vagy javaslatait.'],
        ['Close', 'Bezárás'],
      ]);
      const placeholders = new Map([
        ['Start writing here...', 'Írja meg véleményét...'],
        ['Your email address', 'Az Ön e-mail-címe'],
        ['Display name', 'Megjelenített név'],
      ]);
      const labels = new Map([
        ['Close review form', 'Véleményírás bezárása'],
        ['Review form pages', 'A véleményűrlap oldalai'],
        ['Rating', 'Értékelés'],
        ['Privacy and Terms', 'Adatvédelem és feltételek'],
        ['Review form navigation', 'Navigáció a véleményűrlapon'],
        ['Previous step', 'Előző lépés'],
        ['Next step', 'Következő lépés'],
        ['Share a picture', 'Kép megosztása'],
      ]);
      const translate = (root) => {
        if (!(root instanceof Element) && root !== document.body) return;
        const selector = '.jdgm-widget, .jdgm-write-review-modal, .jdgm-rev-widg';
        const scopes = root === document.body ? [...document.querySelectorAll(selector)] : [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
        for (const scope of scopes) {
          const nodes = [];
          for (const element of [scope, ...scope.querySelectorAll('*')]) {
            for (const node of element.childNodes) if (node.nodeType === 3) nodes.push(node);
          }
          for (const node of nodes) {
            const value = node.nodeValue.replace(/\s+/g, ' ').trim();
            const replacement = text.get(value);
            if (!replacement) continue;
            const leading = node.nodeValue.match(/^\s*/)?.[0] || '';
            const trailing = node.nodeValue.match(/\s*$/)?.[0] || '';
            node.nodeValue = leading + replacement + trailing;
          }
          for (const element of scope.querySelectorAll('[placeholder]')) {
            const replacement = placeholders.get(element.getAttribute('placeholder'));
            if (replacement) element.setAttribute('placeholder', replacement);
          }
          for (const element of scope.querySelectorAll('[aria-label]')) {
            const value = element.getAttribute('aria-label');
            const star = value.match(/^(\d+) stars?$/);
            element.setAttribute('aria-label', star ? star[1] + ' csillag' : labels.get(value) || value);
            if (star && element.hasAttribute('title')) element.setAttribute('title', star[1] + ' csillag');
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__gdpr-statement')) {
            if (!element.textContent.includes("We'll only contact you")) continue;
            element.innerHTML = 'Csak szükség esetén keressük meg a véleményével kapcsolatban. A vélemény elküldésével elfogadja a <a href="https://judge.me/terms" target="_blank" rel="nofollow noopener">felhasználási feltételeket</a> és az <a href="https://judge.me/privacy" target="_blank" rel="nofollow noopener">adatvédelmi tájékoztatót</a>.';
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__media-upload-prompt')) {
            if (!element.textContent.includes('Click to upload')) continue;
            element.innerHTML = '<b>Kattintson a feltöltéshez</b>, vagy húzza ide a fájlt';
          }
        }
      };
      const run = () => translate(document.body);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
      else run();
      new MutationObserver(() => run()).observe(document.documentElement, { childList: true, subtree: true });
})();
